var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviousIcon = function SvgPreviousIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M5.528 10c0-.418.18-.776.478-1.015l6.69-5.854c.478-.418 1.135-.358 1.553.12.358.477.358 1.135-.12 1.493L8.276 9.88q-.09.09 0 .179l5.853 5.136c.478.418.538 1.075.12 1.553s-1.075.538-1.553.12l-.06-.06-6.63-5.794A1.37 1.37 0 0 1 5.528 10"
  })));
};
export { SvgPreviousIcon as ReactComponent };